// https://github.com/SDBridge/SDBridgeSwift
// https://github.com/wendux/DSBridge-Android
import dsbridge from 'dsbridge'
import { isIOS, isAndroid } from './util'

function call(eventName, params, callback) {
    if (isIOS) {
        window.WebViewJavascriptBridge.callHandler(eventName, params, callback)
    }
    if (isAndroid) {
        dsbridge.call(eventName, params, callback)
    }
}

function register(eventName, handler) {
    if (isIOS) {
        window.WebViewJavascriptBridge.registerHandler(eventName, handler)
    }
    if (isAndroid) {
        dsbridge.register(eventName, handler)
    }
}

export default {
    call,
    register
}

